import { styled } from '@mui/system'
import { colors, fontSizes } from '../../Components/consts'

export const PageWrapper = styled('div')({
  backgroundColor: colors.offWhite,
  minHeight: '100vh',
  color: colors.text,
})

export const HeaderContainer = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 10,
  maxHeight: 190,
  overflow: 'hidden',
  borderRadius: 10,
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}))

export const HeaderLogoCon = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 8,
  width: 250,
  [theme.breakpoints.down('md')]: {
    width: 125,
  },
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
}))

export const PageTitle = styled('h1')(({ theme }) => ({
  fontSize: fontSizes.xlarge,
  fontWeight: 800,
  margin: 0,
  textAlign: 'center',
  color: colors.text,
  textTransform: 'uppercase',
  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.semiLarge,
  },
}))

export const LeaderboardsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  margin: theme.spacing(0, 2),
  gap: 20,
  flexWrap: 'wrap',
  [theme.breakpoints.down('md')]: {
    gap: 10,
  },
}))

export const LoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50vh',
})
